import React from "react";
import styled from "styled-components";

const StyledHistogram = styled.div`
    margin-top: 8px;
    display: flex;
    height: 80px;
    padding: 0 10px;
    width: 100%;
    align-items: flex-end;
    position: relative;
    bottom: -5px;
`;

const Column = styled.div`
    background: ${({ selected, theme }) =>
        selected ? theme.colors.tertiary[600] : theme.colors.breathing};
    height: ${(props) => props.height}%;
    flex-grow: 1;
`;

export function FilterHistogram({
    counts,
    range,
    bucketsNumber,
    bucketInterval,
    dataTestId = "filter-histogram"
}) {
    const minRange = range[0] || 0;
    const maxRange = range[1] || bucketsNumber * bucketInterval;

    const maxCount = Math.max(...Object.values(counts));
    // create an array of undefined and fill with buckets edges
    const buckets = [...new Array(bucketsNumber)].map((x, index) => index * bucketInterval);

    return (
        <StyledHistogram data-testid={dataTestId}>
            {buckets.map((key) => {
                const count = counts[key] || 0;
                const percentageOfMax = (count / maxCount) * 100;
                const selected = key >= Number(minRange) && key <= Number(maxRange);

                return <Column key={key} height={percentageOfMax} selected={selected} />;
            })}
        </StyledHistogram>
    );
}
